import { VuexModule, Module, getModule, Action } from "vuex-module-decorators";
import store from "@/store";
import { BaseModule } from "./base.module";
import { ReportsService } from "@/services/api/report.service";
import { ReportPayload } from "~/report.type";

@Module({ dynamic: true, store, name: "report" })
export class ReportVuexModule extends VuexModule {
  @Action
  public async generateReport(
    payload: ReportPayload,
  ): Promise<string | undefined> {
    try {
      if (!payload.path || !payload.type || !payload.filename)
        throw Error("Недостаточно параметров");
      if (payload.action) BaseModule.setLoadingStatus(true);
      const data = await ReportsService.generateReport(payload);
      return data;
    } catch (error) {
      BaseModule.showMessage({ message: error.message, color: "error" });
    } finally {
      BaseModule.setLoadingStatus(false);
    }
  }

  @Action
  public async getDocForSign(reportId: number): Promise<string> {
    return await ReportsService.getDocForSign(reportId);
  }
}

export const ReportsModule = getModule(ReportVuexModule);
